import { render } from "./OapProductShadeList.vue?vue&type=template&id=1e230d9d"
import script from "./OapProductShadeList.vue?vue&type=script&lang=js"
export * from "./OapProductShadeList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__